import { useContext } from 'react';
import { useLanguage } from '../../../../LanguageProvider';
import './SocialHiveDiscover.css'
import { GeneralContext } from '../../../../GeneralProvider';

export default function SocialHiveDiscover({ selectedSearchChannel, isJoined, handleChannelChange, setSelectedSearchChannel, setActiveView }) {
  const { handleJoinChannel, shChannelUri } = useContext(GeneralContext);
  const { getTranslation } = useLanguage();

  if (!selectedSearchChannel) return null;

  return (
    <div style={{ alignItems: 'center', justifyContent: 'center', display: 'flex', height: '100%', width: '100%' }}>

      <div className='sh-discover-container'>

        {selectedSearchChannel.logo ?
          <img
            src={selectedSearchChannel.logo}
            alt={selectedSearchChannel.title}
            width={100}
            height={100}
            style={{ borderRadius: '16px', minHeight: '100px' }}
          />
          :
          <div style={{ width: '100px', height: '100px', backgroundColor: '#ccc', borderRadius: '16px' }} />
        }

        {(selectedSearchChannel.channel_uri === shChannelUri || selectedSearchChannel.channelURI === shChannelUri) &&
          <span className='sh-discover-user-count'>
            {getTranslation("invitedServer")}
          </span>
        }

        <span className='sh-discover-title'>
          {selectedSearchChannel?.title}
        </span>

        <span className='sh-discover-user-count'>
          {selectedSearchChannel?.channelUserCount} {getTranslation("participant")}
        </span>

        {/* <span className='sh-discover-description'>
        {selectedSearchChannel?.description}
      </span> */}

        {isJoined ?
          <div onClick={() => handleChannelChange(selectedSearchChannel)} style={{ alignItems: 'center', justifyContent: 'center', display: 'flex', width: '80%', borderRadius: '4px' }} className="sh-discover-join-button">
            {getTranslation("goToChannel")}
          </div> :

          <>
            {selectedSearchChannel.isPublic === "1" ?
              <div onClick={() => {
                handleJoinChannel(selectedSearchChannel.channelID)
                handleChannelChange(selectedSearchChannel, true)
                setSelectedSearchChannel("")
                setActiveView("")
              }
              }
                style={{ alignItems: 'center', justifyContent: 'center', display: 'flex', width: '80%', borderRadius: '4px' }} className="sh-discover-join-button">
                {getTranslation("joinChannel")}
              </div> :
              <div onClick={() => handleJoinChannel(selectedSearchChannel.channelID)} style={{ alignItems: 'center', justifyContent: 'center', display: 'flex', width: '80%', borderRadius: '4px' }} className="sh-discover-join-button">
                {getTranslation("sendJoinRequest")}
              </div>
            }
          </>
        }
      </div>
    </div>

  )
}
